export const environment = {
  production: true,
  apiUrl: 'https://pro.api.stage.tsin.ca/api',
  apiUrl2: 'https://pro.api.stage.tsin.ca/api',
  userBaseUrl: 'https://auth.api.stage.tsin.ca/api',
  userMgtUrl: 'https://auth.stage.tsin.ca/login',
  authBaseUrl: 'https://auth.api.stage.tsin.ca/api',
  paymentUrl: 'https://pro.api.stage.tsin.ca',
  learningBaseUrl: 'https://lms.api.stage.tsin.ca/api',
  salt: 'ZC\f?.Kp[jnhXf3-"<f3{/tZS@#~(8on',
  oldApiUrl: 'https://pro.api.stage.tsin.ca/api/',
  jiraLink: 'https://tsin.atlassian.net/servicedesk/customer/portal/8',
  externalApiUrl: 'https://wwus.api.stage.tsin.ca/api',
  /** B4 — Screener Queue & QC Workflow feature flag.
   *  Set to true to enable screener-queue routes in this environment.
   *  Drapeau de fonctionnalité — mettre à true pour activer les routes de file d'attente. */
  featureScreenerQueue: true,
  /** Phase B — Kye AI Agents read-only UI (enabled in stage for UAT).
   *  Phase B — Interface lecture seule des agents IA Kye (activée en stage pour les essais). */
  featureKyeAgents: true,
  /** KYE-A-08 — SUPER_ADMIN-only PII redaction admin tool (enabled in stage for UAT).
   *  KYE-A-08 — Outil d'administration de rédaction de RPI (activé en stage pour les essais). */
  featureKyePiiRedaction: true,
  /** KYE — Admin API test console (enabled in stage for integration validation).
   *  KYE — Console d'essai de l'API Kye (activée en stage pour la validation de l'intégration). */
  featureKyeAdminConsole: true,
};
